/**
 * @deprecated Use hubs
 */
export const endpoint = {
	blueprintSpecIndicatorStatistics: (blueprintId: number, params?: {}) => {
		return getUrl(
			`/api/v2/masterorderguides/${blueprintId}/specindicatorstatistics`,
			params
		);
	},
	customCategory: (customCategoryId: number, params?: {}) => {
		return getUrl(`/api/v3/customcategories/${customCategoryId}`, params);
	},
	customCategories: (params?: {}) => {
		return getUrl('/api/v3/customcategories', params);
	},
	setCustomCategories: (params?: {}) => {
		return getUrl('/api/v3/metaproducts/_actions/setcustomcategory', params);
	},
	setMaintainedBys: (params?: {}) => {
		return getUrl('/api/v3/metaproducts/_actions/setmaintainedby', params);
	},
	customersV2: (params?: {}) => {
		return getUrl('/api/v2/customers', params);
	},
	customers: (params?: {}) => {
		return getUrl('/api/v3/customers', params);
	},
	alerts: (params?: {}) => {
		return getUrl('/api/v2/masterorderguides/alerts', params);
	},
	masterOrderGuides: (params?: {}) => {
		return getUrl('/api/v2/masterorderguides', params);
	},
	masterOrderGuide: (masterOrderGuideId: number, params?: {}) => {
		return getUrl(`/api/v2/masterorderguides/${masterOrderGuideId}`, params);
	},
	masterOrderGuideProductDetails: (blueprintId: number, params?: {}) => {
		return getUrl(`/api/v2/masterorderguides/${blueprintId}/products`, params);
	},
	masterOrderGuideNutritionDetails: (blueprintId: number, params?: {}) => {
		return getUrl(
			`/api/v2/masterorderguides/${blueprintId}/products/nutrition`,
			params
		);
	},
	metaProducts: (params?: {}) => {
		return getUrl(`/api/v3/metaproducts`, params);
	},
	metaProduct: (metaProductId: number, params?: {}) => {
		return getUrl(`/api/v3/metaproducts/${metaProductId}`, params);
	},
	optimizationHistory: (params?: {}) => {
		return getUrl(`/api/v3/optimizationhistory`, params);
	},
	masterItems: (params?: {}) => {
		return getUrl(`/api/v3/masteritems`, params);
	},
	productAlerts: (params?: {}) => {
		return getUrl('/api/v3/productalerts', params);
	},
	acknowledgeProductAlerts: (productAlertId: number, params?: {}) => {
		return getUrl(`/api/v3/productalerts/${productAlertId}`, params);
	},
	deleteProductAlerts: (blueprintId: number, params?: {}) => {
		return getUrl(`/api/v3/productalerts/${blueprintId}`, params);
	},
	productLinePrices: (blueprintId: number, params?: {}) => {
		return getUrl(`/api/v3/prices/lines`, { ...params, bpid: blueprintId });
	},
	productHeaderPrices: (blueprintId: number, params?: {}) => {
		return getUrl(`/api/v3/prices/headers`, { ...params, bpid: blueprintId });
	},
	productHeaderPricesAcrossSuppliers: (params?: {}) => {
		return getUrl(`/api/v3/prices/headers`, { ...params });
	},
	productAvailability: (
		blueprintId: number,
		locationCode: string,
		params?: {}
	) => {
		return getUrl('/api/v3/availability', {
			...params,
			bpid: blueprintId,
			loc: locationCode,
		});
	},
	token: (params?: {}) => {
		return getUrl('/api/v3/token', params);
	},
	refreshToken: (params?: {}) => {
		return getUrl('/api/v3/token/refresh', params);
	},
	singleSignOn: (params?: {}) => {
		return getUrl('/api/v3/token/singlesignon', params);
	},
	users: (params?: {}) => {
		return getUrl('/api/v2/users', params);
	},
	user: (userId: number, params?: {}) => {
		return getUrl(`/api/v2/users/${userId}`, params);
	},
	userProfiles: (params?: {}) => {
		return getUrl(`/api/v3/userprofiles`, params);
	},
	userCustomerAssignment: (userId: number, params?: {}) => {
		return getUrl(`/api/v2/users/${userId}/customers`, params);
	},
	userChangeCustomerAssignment: (userId: number, params?: {}) => {
		return getUrl(
			`/api/v2/users/${userId}/_actions/changecustomerassociation`,
			params
		);
	},
	products: (params?: {}) => {
		return getUrl(`/api/v3/products`, params);
	},
	lookUpProducts: (params: {}) => {
		return getUrl(`/api/v3/products/lookup`, params);
	},
	lookUpProductsBySupplierID: (params?: {}) => {
		return getUrl(`/api/v3/products/lookupBySupplierId`, params);
	},
	restrictProducts: (restrictionIds?: number[], params?: {}) => {
		return getUrl(`/api/v3/restrictions`, { ...params, restrictionIds });
	},
	getRestrictions: (params?: {}) => {
		return getUrl(`/api/v3/restrictions`, params);
	},
	deleteRestrictions: (params?: {}) => {
		return getUrl(`/api/v3/restrictions/delete`, params);
	},
	productSearchHeaders: (params?: {}) => {
		return getUrl(`/api/v3/products/search`, params);
	},
	productSearch: (params?: {}) => {
		return getUrl('/api/v3/search', params);
	},
	changePassword: (userId: number, params?: {}) => {
		return getUrl(`/api/v2/users/${userId}/_actions/changepassword/`, params);
	},
	reports: (params?: {}) => {
		return getUrl('/api/v3/report/customer-reports', params);
	},
	newReportRequest: (params?: {}) => {
		return getUrl('/api/v3/report/new-report-request', params);
	},
	reportRequestsByCustomer: (customerId: number, params?: {}) => {
		return getUrl(
			`/api/v3/report/customer-requestable-reports/${customerId}`,
			params
		);
	},
	suppliers: (params?: {}) => {
		return getUrl('/api/v2/suppliers', params);
	},
	distributionCenters: (customerId: number, params?: {}) => {
		return getUrl(
			`/api/v3/syscoselfservice/customers/distributioncenters?customerId=${customerId}`,
			params
		);
	},
	recommendations: (params?: {}) => {
		return getUrl('/api/v2/recommendations/getequivalencies', params);
	},
	massImportRequest: (params?: {}) => {
		return getUrl('/api/v4/massimportrequests', params);
	},
	locationsMassImportRequest: (params?: {}) => {
		return getUrl('/api/v3/massimportrequests/locations', params);
	},
	massImportTemplate: (params?: {}) => {
		return getUrl(
			'/api/v4/massimportrequests/download/massimporttemplate',
			params
		);
	},
	bulkApplyTemplate: (params?: {}) => {
		return getUrl(
			'/api/v4/massimportrequests/download/bulkapplymassimporttemplate',
			params
		);
	},
	dynamicMassImportTemplate: (params?: {}) => {
		return getUrl(
			'/api/v4/massimportrequests/download/dynamicmassimporttemplate',
			params
		);
	},
	locationsMassImportTemplate: (params?: {}) => {
		return getUrl(
			'/api/v3/massimportrequests/download/massimporttemplate/locations',
			params
		);
	},
	massImportInProgressForCustomer: (params?: {}) => {
		return getUrl(`/api/v3/massimportrequests/massimportinprogress/`, params);
	},
	locationsMassImportInProgressForCustomer: (params?: {}) => {
		return getUrl(
			`/api/v3/massimportrequests/massimportinprogress/locations`,
			params
		);
	},
	getCustomer: (customerId: number, params?: {}) => {
		return getUrl(`/api/v3/customers/${customerId}`, params);
	},
	syscoSelfService: {
		getCustomers: (currentPage: number, itemsPerPage: number, params?: {}) => {
			return getUrl('/api/v3/syscoselfservice/customers', {
				...params,
				itemsPerPage,
				currentPage,
			});
		},
		createCustomer: (params?) => {
			return getUrl('/api/v3/syscoselfservice/customers', { ...params });
		},
		getCustomCategoriesForCustomer: (
			customerId: number,
			pi: number,
			ps: number,
			params?: {}
		) => {
			return getUrl('/api/v3/syscoselfservice/customcategory', {
				...params,
				customerId,
				pi,
				ps,
			});
		},
		getLocationsForCustomer: (
			customerId: number,
			pi: number,
			ps: number,
			params?: {}
		) => {
			return getUrl('/api/v3/syscoselfservice/location', {
				...params,
				customerId,
				pi,
				ps,
			});
		},
		createLocation: (customerId, params?) => {
			return getUrl(
				`/api/v3/syscoselfservice/customers/${customerId}/locations`,
				params
			);
		},
	},
	keepAlive: '/keepalive',
	logout: '/logout?auto=true',
	login: '/login',
};

function getUrl(baseUrl, params) {
	return baseUrl + toQueryString(params);
}

function toQueryString(params) {
	if (!params) {
		return '';
	}

	return (
		'?' +
		Object.keys(params)
			.filter(
				(key) =>
					params[key] !== undefined &&
					params[key] !== null &&
					!(params[key] instanceof Array && params[key].length === 0)
			)
			.map((key) =>
				params[key] instanceof Array
					? `${encodeURIComponent(key)}=${params[key].join(
							`&${encodeURIComponent(key)}=`
					  )}`
					: `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
			)
			.join('&')
	);
}
